<template>
    <router-view v-if="act"></router-view>
    <div class="tip" v-else-if="act === false">活动已下线</div>
</template>

<script>
    export default {
        name: "Alias",
        computed: {
            act() {
                return this.$store.getters.info;
            },
        },
        created() {
            this.$store.dispatch("getAct", this.$route.params.alias);
        }
    }
</script>

<style scoped lang="less">
    .tip {
        margin-top: 200px;
        color: #999;
        text-align: center;
    }
</style>
